<template>
  <div class="mc-wrapper">
    <div class="mc-container">
      <div class="mc-account">
        <div class="mc-account__content">
          <div class="mc-account__content-title">
            Дорогие покупатели!
          </div>
          <p>
            С радостью сообщаем вам о запуске бонусной программы лояльности MCBUY.
          </p>
          <p>
            Для того, чтобы стать участником бонусной программы лояльности MCBUY, совершите первую покупку в интернет-магазине&nbsp;<router-link to="/catalog/">www.mcbuy.ru.</router-link>
          </p>
          <router-link to="/catalog/" class="mc-button mc-button--color">
            Перейти в каталог
          </router-link>
          <p>
            После покупки вещей из новой коллекции вам будут начисляться бонусные баллы, исходя из текущего статуса вашей бонусной карты.
          </p>
          <p>
            Постепенно сумма накопленных баллов будет автоматически изменять статус вашей карты и повышать процент от покупок, который будет зачисляться на карту.
          </p>
          <p>
            Переход на новый процент начисления Бонуса будет происходить автоматически.
          </p>
          <p>
            При подтверждении заказа менеджером вы сами выбираете — тратить или копить баллы. Чтобы потратить бонусы, сообщите об этом менеджеру во время звонка.
          </p>
          <div v-if="loyaltyLoaded" class="mc-cards-slider">
                <swiper
                    wrapperTag="ul"
                    slides-per-view="auto"
                    :freeMode="true"
                    :modules="modules"
                    :pagination="false"

                    :space-between="10"
                    class="mc-cards-slider__wrapper swiper-free-mode"
                    wrapperClass="mc-cards-slider__list">
                  <swiper-slide v-for="(item, index) in loyalty" class="mc-cards-slider__item" @click="activeTab=index" :class="activeTab==index?'mc-cards-slider__item--active':''" tag="li">
                  <img class="mc-cards-slider__image" :src="item.picture" width="86" height="54" alt="">
                  </swiper-slide>

                </swiper>

          </div>
          <dl v-if="loyaltyLoaded && activeTab !== false && loyalty[activeTab]" class="mc-properties">
            <div class="mc-properties__item">
              <dt class="mc-properties__term">
                Вид карты
              </dt>
              <dd class="mc-properties__value">
                {{ loyalty[activeTab].type }}
              </dd>
            </div>
            <div class="mc-properties__item">
              <dt class="mc-properties__term">
                Условия получения
              </dt>
              <dd class="mc-properties__value" v-html="loyalty[activeTab].reciep">

              </dd>
            </div>
            <div class="mc-properties__item">
              <dt class="mc-properties__term">
                Начисление бонусов
              </dt>
              <dd class="mc-properties__value">
                {{ loyalty[activeTab].accrual }}
              </dd>
            </div>
            <div class="mc-properties__item">
              <dt class="mc-properties__term">
                Бонусы в День Рождения
              </dt>
              <dd class="mc-properties__value">
                {{ loyalty[activeTab].bday }}
              </dd>
            </div>
          </dl>
          <p>
            Правила начисления и списания бонусов:
          </p>
          <ul>
            <li>
              1 бонус = 1 рубль
            </li>
            <li>
              Бонусы начисляются на Счет Участника программы за совершение покупок на сайте и становятся активными через 15 дней с момента оплаты.
            </li>
            <li>
              Бонусы используются для оплаты последующих покупок в торговой точке Организатора, которые могут быть оплачены бонусами (не более 90%) и денежными средствами.
            </li>
            <li>
              Вы можете оплатить баллами любой товар из ассортимента интернет-магазина.
            </li>
            <li>
              Оплата бонусами осуществляется через подтверждение заказа менеджером интернет магазина&nbsp;www.mcbuy.ru
            </li>
            <li>
              Карты теряют свой статус, если вы его не подтвердили. Подтверждайте статус карты, ежегодно совершая покупки на сумму: 100 000 ₽ для Silver, 800 000 ₽ для Gold и 1 500 000 ₽ для Platinum.
            </li>
          </ul>
          <p>
            Бонусы не начисляются:
          </p>
          <ul>
            <li>
              за покупку товаров со скидкой,
            </li>
            <li>
              за покупку товаров со сниженной ценой,
            </li>
            <li>
              за покупку товаров по специальным маркетинговым акциям,
            </li>
            <li>
              за использование подарочного Сертификата.
            </li>
          </ul>
          <p>
            С подробной информацией о бонусной программе лояльности MCBUY вы можете ознакомиться в&nbsp;<router-link to="/page/oferta/">Оферте</router-link>
          </p>
          <p>
            Вы можете задать дополнительные вопросы по программе лояльности по телефону службы клиентского сервиса:<br>
            <a @click="tel_open('+78005552748')">+7 (800) 555-27-48</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/navigation';
import {Navigation, Pagination, Scrollbar} from "swiper";
import {mapActions, mapGetters} from "vuex";
import urlopen from "@/mixin/urlopen.vue";

export default {
  beforeRouteLeave(to, from) {
    //if (to.name != 'login')
    //  this.$store.dispatch('unLoader');
  },
  mixins: [urlopen],
  created() {
    this.fetchLoyalty();
  },
  computed: {
    ...mapGetters([
      'loyalty',
      'loyaltyLoading',
      'loyaltyError',
      'loyaltyLoaded'
    ])
  },
  async mounted() {

  },
  methods: {
    ...mapActions([
      'fetchLoyalty'
    ]),
  },
  data: () => ({
    modules: [Navigation, Scrollbar,Pagination],
    activeTab: 0,
    error: [],
    sending: false,
    error_text: [],
  phone: '',
    code: '',
    step: 1
  }),
  components: {
    Swiper, SwiperSlide
  }
}
</script>
